import React from 'react';
import PropTypes from 'prop-types';
import getTranslatedText from '../../../../helper/get_translated_text';
import { toDangerousReactHtml } from '../../../../helper/to_dangerous_react_html';
import TranslationContainer from '../../../translation/translation_container';
import Translation from '../../../translation/translation';
import { formatToCurrency } from '../../../../../_modules/currency/format_to_currency';
import {
  showAction as showInfoPopup,
  setHeaderContentAction as setInfoHeader,
  addBodyContentAction as addInfoBody,
  setBodyButtonTextAction as setInfoButtonText,
  setDispatcherAction as setInfoDispatcher,
  setBodyButtonTextAction,
  showCloseButtonAction,
} from '../../../../../_flux/actions/info_popup_actions';
import { InfoPopupDispatcher } from '../../../../../_constants/info_popup';

export const PriceBuy4Pay3 = ({ priceRaw, currencyIsoCode }) => {
  const onClickLearnMore = (e) => {
    setInfoDispatcher(InfoPopupDispatcher.BUY_4_PAY_3);
    setInfoHeader(getTranslatedText('catalog-no-results-boolean-value-buy_3_for_4'));

    addInfoBody(getTranslatedText('product-tile-buy4pay3-price-learn-more-tooltip'));
    setBodyButtonTextAction(getTranslatedText('catalog-filter-lightbox-reset-close-button'));
    showCloseButtonAction(true);

    showInfoPopup();
  };
  return (
    <div className="buy4pay3-price">
      <div className="buy4pay3-price__label">
        <Translation translationKey="product-tile-buy4pay3-price-label" />{' '}
        <Translation
          translationKey="product-tile-buy4pay3-price-learn-more"
          className={['buy4pay3-price__learn-more']}
          onClick={(e) => onClickLearnMore(e)}
        />
      </div>
      <div className="buy4pay3-price__value">
        <TranslationContainer
          translationKey="product-tile-current-price"
          targetProperty="dangerouslySetInnerHTML"
          transform={toDangerousReactHtml}
          placeholder={{
            price: formatToCurrency((priceRaw * 3) / 4, currencyIsoCode, false, true, { decimalDigits: 2 }),
          }}
        >
          <span className="product-tile__price-current-value" />
        </TranslationContainer>
      </div>
    </div>
  );
};
PriceBuy4Pay3.propTypes = {
  priceRaw: PropTypes.number.isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
};
